import { render, staticRenderFns } from "./ProgramBannerSw.vue?vue&type=template&id=08cc2eda&"
import script from "./ProgramBannerSw.vue?vue&type=script&lang=js&"
export * from "./ProgramBannerSw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports